// Module
var code = `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 48 48"><path d="M9 15h6V9H9zm12-6v6h18V9zM9 27h6v-6H9zm12 0h18v-6H21zM9 39h6v-6H9zm12 0h18v-6H21z"></path></svg>`;
// Exports
export default code;